import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CSSTransition } from 'react-transition-group';
import './index.css';

export default class ErrorMessage extends Component{

    render() {
        let buttons = null;
        if(this.props.buttons){
            buttons = this.props.buttons.map((x) => {
                return <button onClick={x.callback} key={x.text}>{x.text}</button>
            });
        }

        return (
            <CSSTransition in={this.props.show} timeout={0} className='ErrorMessage'>
                <div>
                    <div>{this.props.errMsg}</div>
                    {buttons}
                </div>
            </CSSTransition>
        )
    }
}

ErrorMessage.propTypes = {
    show: PropTypes.bool,
    errMsg: PropTypes.string,
    buttons: PropTypes.array,
};